(function () {
  var pendingCartCheck = null;
  var confirmedEmpty = false;

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function cartJsonUrl() {
    return rootUrl() + 'cart.js';
  }

  function isAddonRow(row) {
    if (!row) return false;
    if (row.classList.contains('cart-items__nested-line')) return true;
    if (row.classList.contains('av-cart-addon-row')) return true;
    if (row.dataset && row.dataset.avAddonKey) return true;
    if (row.dataset && row.dataset.parentKey) return true;
    return false;
  }

  function configuredCartCountFromRows(root) {
    /*
      Only real cart line rows have data-key. The header row also uses
      .cart-items__table-row, so never count that.
    */
    var rows = Array.prototype.slice.call(root.querySelectorAll('.cart-items__table-row[data-key]'));
    var count = 0;

    rows.forEach(function (row) {
      if (isAddonRow(row)) return;

      var quantityInput = row.querySelector('input[name^="updates"], input[data-cart-quantity]');
      var quantity = quantityInput ? parseInt(quantityInput.value || quantityInput.getAttribute('value') || '1', 10) : 1;

      if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
      count += quantity;
    });

    return count;
  }

  function hasPendingCartUpdate(component) {
    if (!component) return false;
    if (component.classList.contains('cart-items-disabled')) return true;
    if (component.querySelector('.cart-items__table-row.removing')) return true;
    return false;
  }

  function configuredCartCountFromCartJson(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (total, item) {
      var properties = item.properties || {};
      if (properties._av_addon_key) return total;
      return total + (Number(item.quantity) || 0);
    }, 0);
  }

  function confirmCartIsVisuallyEmpty() {
    /*
      Confirm against Shopify's current cart before swapping the UI. This prevents
      the empty screen from rendering while Shopify is still processing a remove
      request, which was causing the removed line to come back.
    */
    if (confirmedEmpty) return Promise.resolve(true);

    return fetch(cartJsonUrl(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) return false;
        return response.json();
      })
      .then(function (cart) {
        var isEmpty = configuredCartCountFromCartJson(cart) === 0;
        confirmedEmpty = isEmpty;
        return isEmpty;
      })
      .catch(function () {
        return false;
      });
  }

  function findEmptyTemplate(component) {
    if (!component) return null;

    var localTemplate = component.querySelector('#empty-cart-template');
    if (localTemplate instanceof HTMLTemplateElement) return localTemplate;

    var drawerTemplate = component.closest('cart-drawer-component')?.querySelector('#empty-cart-template');
    if (drawerTemplate instanceof HTMLTemplateElement) return drawerTemplate;

    var pageTemplate = document.querySelector('main #empty-cart-template');
    if (pageTemplate instanceof HTMLTemplateElement) return pageTemplate;

    var anyTemplate = document.getElementById('empty-cart-template');
    if (anyTemplate instanceof HTMLTemplateElement) return anyTemplate;

    return null;
  }

  function updateEmptyStateClasses(component) {
    var dialog = component.closest('.cart-drawer__dialog');
    var drawer = component.closest('cart-drawer-component');
    var page = component.querySelector('.cart-page') || component.closest('.cart-page');

    if (page) {
      page.classList.add('cart-page--empty');
    }

    if (dialog) {
      dialog.classList.add('cart-drawer--empty');
      dialog.setAttribute('aria-labelledby', 'cart-drawer-heading-empty');
      dialog.setAttribute('cart-summary-sticky', 'false');
    }

    if (drawer) {
      drawer.classList.add('cart-drawer--empty');
    }
  }

  function replaceWithEmptyTemplate(component) {
    if (!component || component.dataset.avEmptyRendered === 'true') return;

    var template = findEmptyTemplate(component);
    if (!(template instanceof HTMLTemplateElement)) return;

    var clone = document.importNode(template.content, true);
    component.replaceChildren(clone);
    component.dataset.avEmptyRendered = 'true';
    updateEmptyStateClasses(component);
    normalizeEmptyContinueLinks(component);
  }

  function normalizeEmptyContinueLinks(root) {
    root.querySelectorAll('.cart-items__empty-button').forEach(function (link) {
      link.setAttribute('href', rootUrl());
    });
  }

  function checkComponent(component) {
    if (!component) return;

    normalizeEmptyContinueLinks(component);

    if (component.querySelector('.cart-page--empty, .cart-drawer--empty, .cart-drawer__heading--empty')) {
      component.dataset.avEmptyRendered = 'true';
      return;
    }

    if (!component.querySelector('.cart-form')) return;

    /*
      Do not swap to the empty template while a remove animation or Ajax cart
      update is in progress. Let Shopify finish first.
    */
    if (hasPendingCartUpdate(component)) return;

    if (configuredCartCountFromRows(component) !== 0) return;

    confirmCartIsVisuallyEmpty().then(function (isEmpty) {
      if (!isEmpty) return;
      if (hasPendingCartUpdate(component)) return;
      if (configuredCartCountFromRows(component) !== 0) return;
      replaceWithEmptyTemplate(component);
    });
  }

  function checkAll() {
    document.querySelectorAll('cart-items-component').forEach(checkComponent);
    normalizeEmptyContinueLinks(document);
  }

  function scheduleCheck(delay) {
    window.setTimeout(checkAll, delay || 100);
  }

  document.addEventListener('DOMContentLoaded', checkAll);

  document.addEventListener('cart:update', function () {
    confirmedEmpty = false;
    scheduleCheck(250);
    scheduleCheck(700);
    scheduleCheck(1300);
  });

  document.addEventListener('cart:refresh', function () {
    confirmedEmpty = false;
    scheduleCheck(250);
    scheduleCheck(700);
    scheduleCheck(1300);
  });

  document.addEventListener('click', function (event) {
    var removeButton = event.target && event.target.closest && event.target.closest('.cart-items__remove, [data-cart-line-remove], button[name="remove"]');
    var quantityButton = event.target && event.target.closest && event.target.closest('cart-quantity-selector-component button, quantity-selector-component button');

    if (removeButton || quantityButton) {
      confirmedEmpty = false;
      scheduleCheck(650);
      scheduleCheck(1200);
      scheduleCheck(2000);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target && event.target.closest && event.target.closest('.cart-form input, cart-quantity-selector-component input, quantity-selector-component input');

    if (input) {
      confirmedEmpty = false;
      scheduleCheck(650);
      scheduleCheck(1200);
    }
  }, true);

  var observer = new MutationObserver(function () {
    window.clearTimeout(pendingCartCheck);
    pendingCartCheck = window.setTimeout(checkAll, 260);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'data-key', 'data-av-addon-key']
  });
})();
